export default "__VITE_ASSET__be1a7423__"